/**
 * A small catalog of Freemarker building blocks an author can insert into a
 * notification body from the visual editor. Directives insert as chips (they
 * survive the round trip); interpolations insert as plain, editable text.
 */
export interface FreemarkerSnippet {
  /** Menu label. */
  label: string;
  /** The Freemarker source inserted at the caret. */
  snippet: string;
  /** One-line hint shown as the option's tooltip. */
  description: string;
}

export const FREEMARKER_SNIPPETS: FreemarkerSnippet[] = [
  {
    label: 'If',
    snippet: '<#if condition>\n\n</#if>',
    description: 'Show content only when a condition is true.',
  },
  {
    label: 'If / Else',
    snippet: '<#if condition>\n\n<#else>\n\n</#if>',
    description: 'Show one block when true, another when false.',
  },
  {
    label: 'Loop over a list',
    snippet: '<#list items as item>\n  ${item}\n</#list>',
    description: 'Repeat content for every item in a list.',
  },
  {
    label: 'Exists check',
    snippet: '<#if value??>\n\n</#if>',
    description: 'Run only when a variable is present (not missing/null).',
  },
  {
    label: 'Default value',
    snippet: '${value!"—"}',
    description: 'Fall back to a value when the variable is missing.',
  },
  {
    label: 'Uppercase',
    snippet: '${value?upper_case}',
    description: 'Render a value in UPPER CASE.',
  },
  {
    label: 'Capitalise first letter',
    snippet: '${value?cap_first}',
    description: 'Capitalise the first letter of a value.',
  },
  {
    label: 'Format a date',
    snippet: '${date?string("dd MMM yyyy")}',
    description: 'Render a date with an explicit format.',
  },
  {
    label: 'Format a number',
    snippet: '${amount?string(",##0.00")}',
    description: 'Render a number with thousands separators and decimals.',
  },
  {
    label: 'Comment',
    snippet: '<#-- note -->',
    description: 'A note that never appears in the sent email.',
  },
];
